import {
    matrix,
    transpose,
    multiply,
    add,
    subtract,
} from 'mathjs';

function rotatePolygon(points, center, angle) {
    const polygon = transpose(matrix(points.map(point => [point.x, point.y])));
    const centroid = transpose(matrix([...new Array(points.length)].map(() => [center.x, center.y])));
    const rotation = matrix([
        [Math.cos(angle), -Math.sin(angle)],
        [Math.sin(angle), Math.cos(angle)],
    ]);

    const rotatedPolygon = add(multiply(rotation, subtract(polygon, centroid)), centroid);
    return transpose(rotatedPolygon).toArray().map(item => ({ x: item[0], y: item[1] }));
}

export default rotatePolygon;
